<template>
  <div>
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <h2 class="text-primary" style="margin-bottom: 0px">
          <i class="fas fa-bell" /> Notificações
        </h2>
      </div>
    </div>
    <hr />
    <table-paginator :data="notifications" @pagechange="handlePageChange($event)">
      <template v-for="notification in notifications.data">
        <div class="row">
          <div class="col-md-6">
            <!-- {{ notification }} -->
            <notification-label :notification="notification" />
          </div>
        </div>
        <hr />
      </template>
    </table-paginator>
  </div>
</template>

<script>

import notificationLabel from "@/components/notification/sections/NotificationLabel";
import TablePaginator from "@/components/sections/TablePaginator";

export default {
  components: {
    notificationLabel,
    TablePaginator
  },

  mounted() {
    this.getNotifications();
    this.$store.commit("pageHasLoaded");
  },

  data: () => ({
    notifications: {},
    params : {
      page : 1
    }
  }),

  methods: {
    async getNotifications() {
      this.notifications = await this.$store.dispatch(
        "notification/getNotifications", this.params
      );
    },

    handlePageChange(page) {
      this.params.page = page 
      this.getNotifications()
    },
  },
};
</script>

<style>
</style>